import { render, staticRenderFns } from "./InquriryList.vue?vue&type=template&id=1ec9de5a&scoped=true&"
import script from "./InquriryList.vue?vue&type=script&lang=js&"
export * from "./InquriryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec9de5a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSharedDialogsConfirm: require('/app/components/ui/shared/dialogs/Confirm.vue').default})
